import React from 'react';
import { Link } from 'react-router-dom';

const getServiceIcon = (title) => {
  if (title.includes('Gold Online')) return 'fa-coins';
  if (title.includes('Vault')) return 'fa-vault';
  if (title.includes('Bullion Insurance')) return 'fa-shield-alt';
  if (title.includes('Privé Private Wealth')) return 'fa-utensils';
  if (title.includes('Lounge') || title.includes('Bakery')) return 'fa-utensils';
  if (title.includes('Curated')) return 'fa-calendar-alt';
  if (title.includes('Gift of Gold') || title.includes('Brand Partners')) return 'fa-gift';
  if (title.includes('VIP Protect') || title.includes('Chauffeur')) return 'fa-concierge-bell';
  if (title.includes('Luxury Travel') || title.includes('Safari')) return 'fa-plane-departure';
  if (title.includes('Super Car') || title.includes('Fleet')) return 'fa-car-side';
  if (title.includes('Leading Ladies')) return 'fa-crown';
  if (title.includes('AI Tutor') || title.includes('Future Leaders')) return 'fa-graduation-cap';
  if (title.includes('Global Wealth Advisory')) return 'fa-chart-line';
  if (title.includes('Euro Africa Insurance')) return 'fa-shield-alt';
  if (title.includes('Bullion Finance') || title.includes('Islamic Finance')) return 'fa-university';
  if (title.includes('Property Investment')) return 'fa-building';
  if (title.includes('Jewellery')) return 'fa-gem';
  if (title.includes('Finance') || title.includes('Fiduciary')) return 'fa-file-invoice-dollar';
  if (title.includes('Spa') || title.includes('Wellness')) return 'fa-spa';
  if (title.includes('Concierge')) return 'fa-concierge-bell';
  if (title.includes('Real Estate')) return 'fa-home';
  return 'fa-star';
};

const ServiceCard = ({ title, link, icon, locked, requiredTier }) => {
  const serviceIcon = icon || getServiceIcon(title);
  
  if (locked) {
    return (
      <div className="service-card" style={{
        background: 'linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%)',
        border: '1.5px dashed rgba(205, 182, 136, 0.3)',
        cursor: 'not-allowed',
        opacity: '0.6',
        position: 'relative'
      }}>
        <div style={{
          position: 'absolute',
          top: '8px',
          right: '8px',
          background: 'linear-gradient(135deg, #e0c68a 0%, #CDB688 100%)',
          borderRadius: '50%',
          width: '22px',
          height: '22px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0
        }}>
          <i className="fas fa-lock" style={{color: 'white', fontSize: '9px'}}></i>
        </div>
        <div style={{
          fontSize: 'clamp(28px, 8vw, 32px)',
          color: '#d0d0d0',
          marginBottom: '6px',
          flexShrink: 0
        }}>
          <i className={`fas ${serviceIcon}`}></i>
        </div>
        <div className="service-title" style={{
          color: '#999',
          marginBottom: '4px'
        }}>
          {title}
        </div>
        <div style={{
          fontSize: '8px',
          color: '#CDB688',
          fontWeight: '600',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '3px',
          marginTop: 'auto',
          flexShrink: 0
        }}>
          <i className="fas fa-crown" style={{fontSize: '7px'}}></i>
          {requiredTier}
        </div>
      </div>
    );
  }

  return (
    <Link to={link} className="service-card">
      <div style={{
        fontSize: 'clamp(28px, 8vw, 32px)',
        color: '#CDB688',
        marginBottom: '6px',
        flexShrink: 0
      }}>
        <i className={`fas ${serviceIcon}`}></i>
      </div>
      <div className="service-title">{title}</div>
    </Link>
  );
};

export default ServiceCard;
